module.exports = __webpack_public_path__ + "img/Network-Banner.db59430.webp";